module.exports = __webpack_public_path__ + "img/testimonial-branko.2973948a.png";